import { productSpecificationsEn as base } from './product-specifications-en';

export const productSpecificationsTr = {
  ...base,
  admin: {
    nav: 'Ürün spesifikasyonları',
    title: 'Ürün spesifikasyonları',
    description:
      'Yeniden kullanılabilir özellikleri, şemaları, beyanları ve sürümlü PDF düzenlerini tanımlayın.',
  },
  tabs: {
    schemas: 'Şemalar',
    properties: 'Özellik kütüphanesi',
    units: 'Birimler',
    pdfTemplates: 'PDF düzenleri',
    declarations: 'Beyanlar',
    settings: 'Ayarlar',
  },
  actions: {
    create: 'Spesifikasyon oluştur',
    openRevision: 'Revizyonu aç',
    backToOverview: 'Genel görünüme dön',
    backToProduct: 'Ürüne dön',
    preview: 'Önizleme',
    publish: 'Yayınla',
    validate: 'Doğrula',
    submit: 'İncelemeye gönder',
    requestChanges: 'Değişiklik iste',
    approve: 'Onayla',
    withdraw: 'Geri çek',
    generatePdf: 'PDF oluştur',
    download: 'İndir',
    addRow: 'Satır ekle',
    moveUp: 'Yukarı taşı',
    moveDown: 'Aşağı taşı',
  },
  fields: {
    name: 'Ad',
    translatedName: 'Çevrilmiş ad',
    title: 'Başlık',
    text: 'Metin',
    key: 'Teknik anahtar',
    type: 'Tür',
    description: 'Açıklama',
    schema: 'Şema',
    revision: 'Revizyon',
    version: 'Sürüm',
    validity: 'Geçerlilik',
    validFrom: 'Geçerlilik başlangıcı',
    changeReason: 'Değişiklik nedeni',
    reason: 'Gerekçe',
    translationStatus: 'Çeviri durumu',
    sectionKey: 'Bölüm anahtarı',
    sectionTitle: 'Bölüm başlığı',
    columns: 'Sütunlar',
    pageBreakBefore: 'Öncesinde sayfa sonu',
    required: 'Zorunlu',
    dimension: 'Boyut',
    defaultUnit: 'Varsayılan birim',
    translatable: 'Çevrilebilir',
    sensitive: 'Hassas',
    reportable: 'Raporlanabilir',
    symbol: 'Sembol',
    decimalPlaces: 'Ondalık basamak',
    conversionFactor: 'Dönüşüm katsayısı',
    conversionOffset: 'Dönüşüm ofseti',
    currency: 'Para birimi',
    minimum: 'Minimum',
    maximum: 'Maksimum',
    value: 'Değer',
    unit: 'Birim',
    tolerance: 'Tolerans',
    toleranceType: 'Tolerans türü',
    measurementMethod: 'Ölçüm yöntemi',
    remark: 'Açıklama',
    referenceIds: 'Virgülle ayrılmış dahili referanslar',
    declarationVersionId: 'Beyan sürümü',
    confirmed: 'Onaylandı',
    confirmationRequired: 'Onay gerekli',
  },
  values: { none: 'Yok', required: 'Zorunlu', openEnded: 'süresiz', yes: 'Evet', no: 'Hayır' },
  toleranceTypes: { ABSOLUTE: 'Mutlak', PERCENT: 'Yüzde' },
  states: {
    loadError: 'Spesifikasyon verileri yüklenemedi.',
    emptyTitle: 'Henüz spesifikasyon yok',
    emptyDescription: 'Yayınlanmış bir şemadan kontrollü ürün spesifikasyonu oluşturun.',
    noRevision: 'Revizyon mevcut değil.',
  },
  product: {
    title: 'Ürün spesifikasyonları',
    description: 'Sürümlü, çok dilli ve onaylanmış ürün bilgileri.',
  },
  create: {
    title: 'Ürün spesifikasyonu oluştur',
    description: 'Yayınlanmış bir şema seçin ve ilk revizyonu tanımlayın.',
    selectSchema: 'Şema seçin',
    success: 'Spesifikasyon oluşturuldu.',
    error: 'Spesifikasyon oluşturulamadı.',
  },
  property: {
    ...base.property,
    title: 'Özellik kütüphanesi',
    description: 'Her sektör için yeniden kullanılabilir tür güvenli tanımlar.',
    add: 'Özellik ekle',
    empty: 'Tanımlanmış özellik yok.',
    createSuccess: 'Özellik oluşturuldu.',
    createError: 'Özellik oluşturulamadı.',
    types: {
      SHORT_TEXT: 'Kısa metin',
      MULTILINE_TEXT: 'Çok satırlı metin',
      RICH_TEXT: 'Güvenli zengin metin',
      INTEGER: 'Tam sayı',
      DECIMAL: 'Ondalık sayı',
      PERCENT: 'Yüzde',
      CURRENCY: 'Para birimi',
      BOOLEAN: 'Evet/Hayır',
      DATE: 'Tarih',
      DATE_TIME: 'Tarih ve saat',
      SINGLE_CHOICE: 'Tek seçim',
      MULTIPLE_CHOICE: 'Çoklu seçim',
      TRANSLATABLE_CHOICE: 'Çevrilebilir seçim',
      MEASUREMENT: 'Birimli değer',
      RANGE: 'Aralık',
      MINIMUM: 'Minimum değer',
      MAXIMUM: 'Maksimum değer',
      TARGET_TOLERANCE: 'Toleranslı hedef',
      COMPARISON_MEASUREMENT: 'Operatörlü ölçüm',
      FORMULA: 'Formül',
      IMAGE: 'Görsel',
      IMAGE_GALLERY: 'Görsel galerisi',
      DMS_FILE: 'DMS dosyası',
      CERTIFICATE: 'Sertifika referansı',
      PRODUCT_REFERENCE: 'Ürün referansı',
      URL: 'URL',
      KEY_VALUE_TABLE: 'Anahtar-değer tablosu',
      CUSTOM_TABLE: 'Özel tablo',
      MATRIX: 'Matris',
      LIST: 'Liste',
      NUMBERED_INSTRUCTIONS: 'Numaralı talimatlar',
      DECLARATION: 'Beyan',
      SECTION_HEADING: 'Bölüm başlığı',
      INFORMATION: 'Bilgi metni',
    },
    configuration: {
      SINGLE_CHOICE: 'İlk seçenek',
      MULTIPLE_CHOICE: 'İlk seçenek',
      TRANSLATABLE_CHOICE: 'İlk seçenek',
      FORMULA: 'Formül ifadesi',
      KEY_VALUE_TABLE: 'İlk sütun',
      CUSTOM_TABLE: 'İlk sütun',
      MATRIX: 'İlk sütun',
    },
  },
  unit: {
    title: 'Birim kütüphanesi',
    description: 'Kiracıya özel boyutlar ve kesin Decimal dönüşümleri.',
    add: 'Birim ekle',
    createSuccess: 'Birim oluşturuldu.',
    createError: 'Birim oluşturulamadı.',
  },
  schema: {
    title: 'Spesifikasyon şemaları',
    description: 'Yeniden kullanılabilir özelliklerden sürümlü formlar oluşturun.',
    add: 'Şema oluştur',
    empty: 'Tanımlanmış şema yok.',
  },
  builder: {
    library: 'Özellik kütüphanesi',
    inspector: 'Denetçi',
    addProperty: '{{name}} ekle',
    dropHint: 'Özelliği buraya bırakın veya ekleme düğmesini kullanın.',
    addSection: 'Bölüm ekle',
    saveSuccess: 'Şema taslağı kaydedildi.',
    saveError: 'Şema kaydedilemedi.',
    versionSuccess: 'Yeni şema sürümü oluşturuldu.',
    draftAlreadyExists: 'Zaten bir taslak sürüm var.',
    validationError: 'Zorunlu anahtarları, çevirileri ve yapılandırmaları kontrol edin.',
    publishSuccess: 'Şema yayınlandı.',
    publishError: 'Şema yayınlanamadı.',
    validationIssues: '{{count}} doğrulama hatası kaldı.',
  },
  editor: {
    saved: 'Kaydedildi',
    unsaved: 'Değişiklikleri kaydet',
    saveError: 'Kaydedilemedi. Eşzamanlı değişikliklerin üzerine yazmadan önce yenileyin.',
    completeness: 'Tamamlanma',
    contents: 'İçindekiler',
    validationSummary: 'Doğrulama hataları',
    sourceText: 'Kaynak metin',
    language: 'Dil',
    workflow: 'İnceleme ve onay',
    pdf: 'PDF belgeleri',
    valid: 'Revizyon geçerli.',
  },
  sources: {
    type: 'Veri kaynağı',
    field: 'Kaynak alanı',
    key: 'Kaynak anahtarı',
    imageVariant: 'Görsel varyantı',
    packagingId: 'Ambalaj kimliği (isteğe bağlı)',
    automaticSelection: 'Otomatik seç',
    dmsCategory: 'DMS kategorisi',
    expression: 'Formül ifadesi',
    market: 'Pazar',
    parameterKey: 'Analiz anahtarı (isteğe bağlı)',
    domainKey: 'Analiz alanı',
    allParameters: 'Tüm parametreleri tablo olarak göster',
    display: 'Gösterim',
    snapshotOnCreate: 'Oluştururken kaynağı dondur',
    refreshOnRevision: 'Yeni revizyonda yenile',
    copyInitially: 'İlk değeri kopyala',
    showLiveInDraft: 'Taslakta canlı kaynağı göster',
    readOnly: 'Salt okunur',
    manuallyOverridable: 'Gerekçeli geçersiz kılmaya izin ver',
    refresh: 'Kaynak verilerini yenile',
    refreshSuccess: 'Kaynak verileri ve köken bilgileri yenilendi.',
    refreshError: 'Kaynak verileri yenilenemedi.',
    warningTitle: 'Eksik veya çelişkili kaynak verileri',
    warningItem: '“{{field}}” kaynak alanı eksik ({{code}}).',
    overrideReason: 'Manuel geçersiz kılma gerekçesi',
    overrideReasonRequired: 'İzlenebilirlik için gerekçe zorunludur.',
    overrideReasonSaved: 'Kayıtlı gerekçe: {{reason}}',
    provenance: 'Kaynak: {{source}} · Sürüm: {{version}}',
    snapshot: 'dondurulmuş anlık görüntü',
    types: {
      MANUAL: 'Manuel giriş',
      PRODUCT_FIELD: 'Ürün ana verisi',
      PRODUCT_CUSTOM_FIELD: 'Özel ürün alanı',
      PRODUCT_CATEGORY: 'Ürün kategorisi',
      PRODUCT_IMAGE: 'Ürün görseli',
      PACKAGING: 'Ambalaj verileri',
      DMS_ATTACHMENT: 'DMS eki',
      FORMULA: 'Formül',
      RECIPE: 'Onaylı reçete',
      PRODUCT_DECLARATION: 'Onaylı beyan',
      ALLERGEN: 'Alerjen verileri',
      NUTRITION: 'Besin değerleri',
      PROCESS_ROUTING: 'Onaylı süreç',
      YIELD: 'Verim',
      ANALYSIS: 'Analiz değerleri',
      MATERIAL_PROFILE: 'Malzeme ana verisi',
    },
    origins: { MANUAL: 'Manuel', AUTOMATIC: 'Otomatik', MANUAL_OVERRIDE: 'Manuel geçersiz kılma' },
    values: {
      articleNumber: 'Ürün numarası',
      name: 'Ad',
      description: 'Açıklama',
      ean: 'EAN',
      manufacturerNumber: 'Üretici numarası',
      weightNetKg: 'Net ağırlık',
      weightGrossKg: 'Brüt ağırlık',
      countryOfOrigin: 'Menşe ülke',
      THUMBNAIL: 'Küçük resim',
      LIST: 'Liste görünümü',
      CATALOG: 'Katalog görünümü',
      DETAIL: 'Ayrıntı görünümü',
      ALL: 'Tümü',
      GENERAL_FILE: 'Genel dosya',
      CERTIFICATE: 'Sertifika',
      DATASHEET: 'Teknik veri sayfası',
      NUMBER: 'Numara',
      NAME: 'Ad',
      DESCRIPTION: 'Açıklama',
      BASE_QUANTITY: 'Referans miktar',
      BASE_UNIT: 'Temel birim',
      COMPONENTS: 'Bileşenler',
      INTERNAL_MATERIAL_COST: 'Dahili malzeme maliyeti',
      DMS_ATTACHMENTS: 'DMS belgeleri',
      PRODUCT_DESIGNATION: 'Ürün tanımı',
      INGREDIENT_TEXT: 'İçindekiler listesi',
      ALLERGEN_TEXT: 'Alerjen bildirimi',
      ADDITIVE_TEXT: 'Katkı maddesi bildirimi',
      WARNING_TEXT: 'Uyarılar',
      COMBINED_TEXT: 'Birleşik beyan metni',
      STEPS: 'Proses adımları',
      INSTRUCTIONS: 'Çalışma talimatları',
      QUALITY_CHECKS: 'Kalite kontrolleri',
      PHOTOS: 'Proses fotoğrafları',
      PERCENT: 'Yüzde',
      FACTOR: 'Faktör',
      STANDARD_UNIT: 'Standart miktar birimi',
      DENSITY: 'Yoğunluk',
      ORIGIN: 'Menşe',
      MANUFACTURER: 'Üretici',
      TECHNICAL_PROPERTIES: 'Teknik özellikler',
      QUALITY_PROPERTIES: 'Kalite özellikleri',
      STORAGE_CONDITIONS: 'Saklama koşulları',
      STORAGE_INSTRUCTIONS: 'Saklama talimatları',
      SHELF_LIFE_DAYS: 'Gün cinsinden raf ömrü',
    },
  },
  impact: {
    title: 'Yeniden inceleme gerekli',
    description: 'Onaylı kaynak verileri değişti. Sonraki onaydan önce etkileri inceleyin.',
    badge: 'İnceleme gerekli',
    count: '{{count}} kaynak değişikliği bu spesifikasyonu etkiliyor.',
    item: '“{{source}}” kaynağı değiştirildi.',
  },
  workflow: {
    submitted: 'Revizyon incelemeye gönderildi.',
    changesRequested: 'Değişiklik istendi.',
    approved: 'Revizyon onaylandı.',
    published: 'Revizyon yayınlandı.',
    withdrawn: 'Revizyon geri çekildi.',
    error: 'İş akışı eylemi başarısız.',
  },
  revisionTools: {
    title: 'Revizyon ve şema sürümü',
    createNext: 'Sonraki revizyonu oluştur',
    created: 'Yeni bir revizyon oluşturuldu.',
    createError: 'Yeni revizyon oluşturulamadı.',
    compare: 'Revizyonla karşılaştır',
    selectRevision: 'Revizyon seç',
    changeCount: '{{count}} değişiklik',
    noChanges: 'Fark bulunamadı.',
    changeKind: { ADDED: 'Eklendi', REMOVED: 'Kaldırıldı', CHANGED: 'Değiştirildi' },
    migration: 'Kontrollü şema geçişi',
    selectSchemaVersion: 'Yayınlanmış şema sürümünü seç',
    migrate: 'Geçirilmiş revizyon oluştur',
    migrated: 'Geçirilmiş taslak revizyon oluşturuldu.',
    migrationError: 'Revizyon geçirilemedi.',
    migrationCategory: {
      unchanged: 'Değişmeyen alanlar',
      new: 'Yeni alanlar',
      removed: 'Kaldırılan alanlar',
      incompatible: 'Uyumsuz alanlar',
      carriable: 'Aktarılabilir değerler',
      manual: 'Elle inceleme',
    },
  },
  settings: {
    title: 'Spesifikasyon ayarları',
    description: 'Genel onay, geçerlilik ve güvenli PDF dosya adı kurallarını yapılandırın.',
    defaultSourceLocale: 'Varsayılan kaynak dil',
    validityWarningDays: 'Geçerlilik uyarısı (gün)',
    fileNamePattern: 'PDF dosya adı kalıbı',
    fileNamePatternHelp:
      'Kullanılabilir belirteçler: {{articleNumber}}, {{specificationKey}}, {{revision}}, {{locale}}.',
    requireFourEyes: 'Varsayılan olarak dört göz onayı iste',
    creatorMayApprove: 'Oluşturanın onaylamasına izin ver',
    createPdfOnPublish: 'Yayınlamada PDF oluştur',
    saved: 'Spesifikasyon ayarları kaydedildi.',
    saveError: 'Spesifikasyon ayarları kaydedilemedi.',
  },
  declaration: {
    title: 'Beyanlar ve sertifikalar',
    description: 'Yasal ve sektörel metinleri yapılandırılabilir sürümler olarak yönetin.',
    createSuccess: 'Beyan oluşturuldu.',
    createError: 'Beyan oluşturulamadı.',
    publishSuccess: 'Beyan yayınlandı.',
    publishError: 'Beyan yayınlanamadı.',
  },
  pdf: {
    ...base.pdf,
    title: 'Spesifikasyon PDF tasarımcısı',
    description: 'Ortak PDF altyapısını kullanan özel dinamik akış düzeni alanı.',
    blockLibrary: 'Blok kütüphanesi',
    inspector: 'Sayfa denetçisi',
    blockText: 'Çevrilmiş blok metni',
    addBlock: 'Blok ekle',
    pagePreview: 'Baskı önizlemesi',
    createSuccess: 'PDF düzeni oluşturuldu.',
    createError: 'PDF düzeni oluşturulamadı.',
    publishSuccess: 'PDF düzeni yayınlandı.',
    publishError: 'PDF düzeni yayınlanamadı.',
    previewError: 'PDF önizlemesi başarısız.',
    previewTitle: 'Spesifikasyon PDF önizlemesi',
    queued: 'PDF oluşturma kuyruğa alındı.',
    combined: 'Birleşik diller',
    attachments: 'İsteğe bağlı DMS ekleri',
    attachmentCount: '{{count}} dondurulmuş ek',
    generateCombined: 'Birleşik çok dilli belge',
    versionCount: '{{count}} sürüm',
    status: {
      PENDING: 'Kuyrukta',
      PROCESSING: 'Oluşturuluyor',
      READY: 'Hazır',
      FAILED: 'Başarısız',
    },
    blocks: {
      COMPANY_LOGO: 'Şirket logosu',
      COMPANY_ADDRESS: 'Şirket adresi',
      DOCUMENT_TITLE: 'Belge başlığı',
      PRODUCT_NAME: 'Ürün adı',
      ARTICLE_NUMBER: 'Ürün numarası',
      PRODUCT_CATEGORY: 'Ürün kategorisi',
      PRODUCT_IMAGE: 'Ürün görseli',
      IMAGE_GALLERY: 'Görsel galerisi',
      SPECIFICATION_NUMBER: 'Spesifikasyon numarası',
      REVISION_NUMBER: 'Revizyon numarası',
      STATUS: 'Durum',
      VALIDITY_DATE: 'Geçerlilik',
      CREATED_DATE: 'Oluşturma tarihi',
      APPROVED_DATE: 'Onay tarihi',
      SECTION: 'Spesifikasyon bölümü',
      PROPERTY: 'Özellik',
      PROPERTY_GROUP: 'Özellik grubu',
      DYNAMIC_TABLE: 'Dinamik tablo',
      MATRIX: 'Matris',
      LONG_TEXT: 'Uzun metin',
      NOTICE: 'Bilgi kutusu',
      CERTIFICATE_LIST: 'Sertifika listesi',
      DMS_FILE_LIST: 'DMS dosya listesi',
      ATTACHMENT_LIST: 'Ek listesi',
      APPROVAL: 'Onay bloğu',
      REVISION_HISTORY: 'Revizyon geçmişi',
      TABLE_OF_CONTENTS: 'İçindekiler',
      HEADER: 'Sayfa üstbilgisi',
      FOOTER: 'Sayfa altbilgisi',
      PAGE_NUMBER: 'Sayfa numarası',
      CONFIDENTIALITY: 'Gizlilik işareti',
      WATERMARK: 'Filigran',
      QR_CODE: 'Doğrulama QR kodu',
      STATIC_TEXT: 'Statik çevrilebilir metin',
      CONDITIONAL: 'Koşullu blok',
    },
  },
  status: {
    schema: { NEW: 'Yeni', DRAFT: 'Taslak', PUBLISHED: 'Yayınlandı', ARCHIVED: 'Arşivlendi' },
    revision: {
      DRAFT: 'Taslak',
      IN_REVIEW: 'İncelemede',
      CHANGES_REQUESTED: 'Değişiklik istendi',
      APPROVED: 'Onaylandı',
      PUBLISHED: 'Yayınlandı',
      SUPERSEDED: 'Yerine yenisi geldi',
      WITHDRAWN: 'Geri çekildi',
    },
    translation: {
      NOT_STARTED: 'Başlanmadı',
      IN_PROGRESS: 'Devam ediyor',
      IN_REVIEW: 'İncelemede',
      APPROVED: 'Onaylandı',
    },
  },
  operators: {
    EQUAL: '=',
    LESS_THAN: '<',
    LESS_THAN_OR_EQUAL: '≤',
    GREATER_THAN: '>',
    GREATER_THAN_OR_EQUAL: '≥',
    RANGE: 'Aralık',
    APPROXIMATELY: 'Yaklaşık',
    NOT_DETECTABLE: 'Tespit edilemez',
    PASSED: 'Geçti',
    FAILED: 'Kaldı',
  },
} as const;
